import { Injectable } from "@angular/core";
import { AlertButton, AlertController, Platform } from "@ionic/angular";
import { Subscription } from "rxjs";
import { DeviceHelper } from "../helpers/device.helper";
import { LoggerService } from "./logs/logger.service";

@Injectable({ providedIn: "root" })
export class BackButtonManagementService {
    private backSubscription: Subscription;
    private backButtonPriority: number = 2000;

    constructor(private platform: Platform,
                private alertController: AlertController,
                private deviceHelper: DeviceHelper,
                private logger: LoggerService) {
    }

    public initialize() {
        if (this.deviceHelper.isRunningOnDevice()) {
            this.backSubscription = this.platform.backButton.subscribeWithPriority(
                this.backButtonPriority,
                async (processNextHandler: () => void) => {

                    let topAlert = await this.alertController.getTop();
                    if (topAlert) {
                        // Chercher et exécuter le handler du bouton cancel s'il existe
                        const cancelButton = topAlert.buttons?.find(button =>
                            (button as AlertButton).role === "cancel",
                        ) as AlertButton;

                        if (cancelButton?.handler) {
                            try {
                                await cancelButton.handler(null);
                            } catch (error) {
                                this.logger.warn(this.constructor.name, "Erreur lors de l'exécution du handler cancel:", error);
                            }
                        }

                        await topAlert.dismiss();
                        return; // Événement capturé, ne pas propager
                    } else {
                        processNextHandler();
                    }
                });
        }
    }

    public destroy() {
        if (this.backSubscription) {
            this.backSubscription.unsubscribe();
        }
    }
}
